import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService, GradeService } from "../../_services";
import { ToastrService } from "ngx-toastr";
import {
  ApiRequest,
  IApiresponse,
  GradeStatusEnum,
  FunctionPackageEnum,
  LogObjectActionTemplateEnum,
} from "../../_models";
import { Observable, Subscription } from "rxjs";
import { Userresponsedto } from "../../_models/user/userresponsedto";
import { Claims } from "../../_models/common/claims";
import { ClaimsService } from "../../_services/common/claims.service";
import {
  IResponseGrade,
  IResponseGradeList,
  IRequestGradeBulkDeactivate,
  RequestGradeBulkDeactivate,
  IRequestGradeListAll,
  RequestGradeListAll,
  RequestGrade,
  IRequestGrade,
} from "src/app/_models/grade/grade";
import { AlertPanelModel } from "src/app/_models/common/alertPanelModel";
import { TranslateService } from "@ngx-translate/core";
import { HowDoIVideoLinks } from "src/app/common/commonvariables";
import { BaseComponent } from "../../shared/base/base-component";
import { AlertService } from "../../alert-panel/alert.service";
import { OrganisationSettingService } from "src/app/_services/organisation-setting/organisation-setting.service";
import { MarketingPopup } from "src/app/_models/common/marketing-popup";
import { LoggingPanelModel } from "../../_models/common/LoggingPanelModel";
import { LoggingPanelService } from "../../_services/logging-panel/logging-panel.service";
import { AppGridComponent } from "src/app/shared/grid/grid-component/grid.component";
import { ColDef } from "ag-grid-community";
import { CountByStatus, GridConfig } from "src/app/_models/common/grid/grid-config";
import { NgOption } from "@ng-select/ng-select";
import { ActionPanelConfig, ActionPanelOutput } from "src/app/_models/common/form/form";
import { ActionPanelComponent } from "src/app/shared/panels/action-panel/action-panel.component";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { GetField } from "src/app/shared/forms/form-functions/form-functions";
import {
  IRequestGradeListForAssignEmployee,
  IResponseGradeListForAssignEmployee,
  RequestGradeListForAssignEmployee,
  AssignCategoriesToGradeListPanelInputModel
} from "../../_models/grade/grade";
import { first } from "rxjs/operators";

@Component({
  selector: 'grade-panel',
  templateUrl: "./grade.component.html",
  styleUrls: ["./grade.component.scss"],
  standalone: false
})
export class GradeComponent extends BaseComponent implements OnInit, OnDestroy {

  @ViewChild(AppGridComponent) gridComponent: AppGridComponent;
  @ViewChild(ActionPanelComponent) actionPanel: ActionPanelComponent;
  howDoIVideoLinks = HowDoIVideoLinks;
  hasFormChanges: boolean;
  videoLink: string = HowDoIVideoLinks.SetupGrades;
  lstClaimants: any[] = [];
  alertSubscription: Subscription;
  currentUserSubscription: Subscription;
  claimsubscription: Subscription;
  currentUser: Userresponsedto;
  claims: Claims;
  showClaimantPanel: boolean;
  assigncategoriestogradePopupModel: MarketingPopup;
  isAssigncategoriestogradeSubscribed: boolean;
  showAssignCategorieToGradePopup: boolean;
  panelHeader: string;
  gradeAllList: IResponseGrade[] = [];
  selectedItemsList: IResponseGrade[] = [];
  gradeList: any[] = [];
  defaultSortColumn = 'gradeStatus';
  gridData: any[] = [];
  gridColumnDefs: ColDef[];
  gridConfigItems: GridConfig;
  gridFilterStatus: number = GradeStatusEnum.Active;
  gridFilterItems: NgOption[] = [
    { id: GradeStatusEnum.Active, name: "Active" },
    { id: GradeStatusEnum.Inactive, name: "Inactive" }
  ];

  actionPanelConfig: ActionPanelConfig = null;
  actionPanelModel: any = null;
  hideActionButtons: boolean = false;
  disableDeactiveButton: boolean = false;
  bulkActionDiv: boolean = false;
  alertPanelModelForBulk: AlertPanelModel = new AlertPanelModel(false, "", [""], "", "", true, this.translate.instant("please_review_or_confirm"));
  alertPanelModelForDeactivatingAllGrades: AlertPanelModel = new AlertPanelModel(false, "", [""], "", "", true, this.translate.instant("please_review_or_confirm"));
  statusValue: number;

  showAssignCategoriesToGradeListPanel: boolean = false;
  assignCategoriesToGradeListPanelInputModel: AssignCategoriesToGradeListPanelInputModel;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private authenticationService: AuthenticationService,
    private gradeService: GradeService,
    private claimsService: ClaimsService,
    private translate: TranslateService,
    private alertService: AlertService,
    private organisationSettingService: OrganisationSettingService,
    private loggingPanelService: LoggingPanelService
  ) {
    super();
    this.claimsubscription = this.claimsService.currentClaims.subscribe((claims) => {
      this.claims = claims;
    });
    this.currentUserSubscription = this.authenticationService.currentUser.subscribe(
      (user) => {
        this.currentUser = user;
      }
    );
    var currentContext = this;
    this.alertSubscription = this.alertService.getUserActionEvent().subscribe((action) => {
      if (action) {
        currentContext.hasFormChanges = false;
        currentContext.onClosePanel();
      }
    });

  }

  ngOnInit(): void {
    this.statusValue = GradeStatusEnum.Active;
    this.showClaimantPanel = false;
    this.hasFormChanges = false;
    this.getAllGradeForOrg();
    this.fnInitialiseGrid();
    this.checkAssigncategoriestogradeSubscribed();
    this.getGradeListForAssignEmployee();
    if (localStorage.getItem("addFromMileageRate")) {
      this.fnShowSaveGradePanel('add', null);
      localStorage.removeItem("addFromMileageRate")
    }

    this.assigncategoriestogradePopupModel = new MarketingPopup(
      this.translate.instant("assign_categories_to_grade"),
      this.translate.instant("assign_categories_to_grade"),
      this.translate.instant("assign_category_grade_description"),
      null,
      "../../assets/svg-icons/GradesToCatoories.png",
      "../../assets/images/GradesToCatoories.png",
      "",
      FunctionPackageEnum.assigncategoriestograde,
      this.translate.instant("assign_categories_to_grade"),
      "assigncategoriestograde",
      0,
      0
    );
  }

  ngOnDestroy() {
    this.alertSubscription.unsubscribe();
    this.claimsubscription.unsubscribe();
    this.currentUserSubscription.unsubscribe();
  }

  canDeactivate(): boolean {
    return !this.hasFormChanges;
  }

  fnInitialiseGrid() {
    this.fnCreateColumnDefs();
    this.fnGetGridConfigItems();
    setTimeout(() => {
      this.gridComponent.initializeGrid();
    }, 100);
  }

  fnCreateColumnDefs() {
    this.gridColumnDefs = [
      {
        headerName: this.translate.instant('grade_name'),
        field: 'gradeName',
        resizable: true,
        sortable: true,
        suppressHeaderMenuButton: true,
        minWidth: 100,
      },
      {
        headerName: this.translate.instant('grade_description'),
        field: 'gradeDescription',
        resizable: true,
        sortable: true,
        suppressHeaderMenuButton: true,
        minWidth: 100,
      },
      {
        headerName: this.translate.instant('grade_status'),
        field: 'gradeStatus',
        resizable: true,
        suppressHeaderMenuButton: true,
        cellRenderer: 'fieldValueRenderer',
        minWidth: 100,
        sortable: false,
        headerComponentParams: [
          { class: 'color-green font-weight-bold', value: GradeStatusEnum.Active, text: this.translate.instant("label_active") },
          { class: 'font-weight-bold', value: GradeStatusEnum.Inactive, text: this.translate.instant("label_inactive") }
        ]
      },
      {
        headerName: this.translate.instant('no_of_claimants'),
        field: 'assignedEmployeeCount',
        resizable: true,
        sortable: true,
        suppressHeaderMenuButton: true,
        minWidth: 200,
        width: 200,
        cellClass: 'text-center',
        headerClass: 'text-center',
        cellRenderer: 'formattedTextRenderer',
        headerComponentParams: {
          class: 'd-inline-block text-logo-blue cursor-pointer text-underline lH-12'
        }
      },
      {
        headerName: this.translate.instant('label_log_history'),
        field: 'log',
        cellRenderer: 'actionRenderer',
        resizable: true,
        suppressHeaderMenuButton: true,
        minWidth: 50,
        headerClass: 'text-center',
        cellClass: 'text-center',
        sortable: false,
        headerComponentParams:
          [
            {
              buttonClass: 'fas fa-file-search',
              buttonTooltip: this.translate.instant('label_log'),
              buttonAlignmentClass: 'text-center position-relative'
            }
          ]
      },
      {
        headerName: "",
        valueGetter: 'data && data.gradeId',
        cellRenderer: 'actionRenderer',
        field: 'userActionField',
        suppressMovable: true,
        suppressHeaderMenuButton: true,
        sortable: false,
        minWidth: 100,
        headerComponentParams:
          [
            {
              buttonClass: 'fas fa-edit color-green',
              buttonTooltip: this.translate.instant('label_edit'),
              userAction: 1
            },
            {
              buttonClass: 'fas fa-copy text-logo-blue',
              buttonTooltip: this.translate.instant('copy'),
              userAction: 2
            }
          ]
      }
    ];
  }

  fnGetGridConfigItems() {

    let filterClass = "d-inline-block cursor-pointer text-underline lH-12 ";
    let totalGradeCount = this.gradeAllList.length;
    let activeGradeCount = this.gradeAllList.filter(g => g.gradeStatus == GradeStatusEnum.Active).length;
    let inactiveGradeCount = this.gradeAllList.filter(g => g.gradeStatus == GradeStatusEnum.Inactive).length;

    let countByStatusArray = [];

    countByStatusArray.push(new CountByStatus("d-block", this.translate.instant('grade_count'), totalGradeCount, false, 0));

    countByStatusArray.push(new CountByStatus(filterClass + "color-green padding-right-10 padding-left-10",
      this.translate.instant('label_active'), activeGradeCount, true, GradeStatusEnum.Active));
    countByStatusArray.push(new CountByStatus(filterClass + "color-grey padding-left-10 border-left-2px",
      this.translate.instant('label_inactive'), inactiveGradeCount, true, GradeStatusEnum.Inactive));

    this.gridConfigItems = new GridConfig(
      false,
      false,
      this.defaultSortColumn,
      "gradeId",
      this.gridFilterStatus,
      true,
      countByStatusArray,
      true,
      true,
      true,
      null,
      'asc',
      40,
      'no_data_availabe',
      null,
      null,
      false, false,
      '',
      '',
      false
    );
  }

  getAllGradeForOrg() {
    let gradeRequest = new ApiRequest<IRequestGradeListAll>(
      "SoloGetAllGradeByOrgId",
      1.0,
      "111"
    );
    let gradeRequestInfo = new RequestGradeListAll(this.claims.OrgId);
    gradeRequest.requestInfo = gradeRequestInfo;
    this.gradeService
      .GetAllGradeByOrgId(gradeRequest)
      .subscribe((response: IApiresponse<IResponseGradeList>) => {
        this.gradeAllList = [];
        if (response.responseInfo != null) {
          this.gradeAllList = response.responseInfo.gradeList;
        }
        this.fnGridFilterChanged(this.gridFilterStatus);
      });
  }

  fnGridFilterChanged(status) {
    this.gridData = [];
    this.gridFilterStatus = status;

    switch (status) {
      case 0:
        this.gridData = this.gradeAllList;
        break;
      default:
        this.gridData = this.gradeAllList.filter(g => g.gradeStatus == status);
        break;
    }

    this.fnHighlightRows();
    this.fnGetGridConfigItems();

    setTimeout(() => {
      this.gridComponent.refreshGridData();
    }, 100);
  }
  isGradePanelOpen: boolean = true;

  fnHighlightRows() {
    let updatedDateTimeFromLocalStorage = localStorage.getItem("gradeUpdatedDateTime" + this.claims.OrgId);

    if (updatedDateTimeFromLocalStorage) {
      let lastUpdateDateTime = new Date(updatedDateTimeFromLocalStorage);
      this.gridData = this.gridData.map(
        (item) => {
          let updateOnDate = new Date(item.updatedOn);
          if (updateOnDate > lastUpdateDateTime) {
            item.isRowHighlighted = true;
          }
          return item;
        });
      localStorage.removeItem("gradeUpdatedDateTime" + this.claims.OrgId);

      setTimeout(() => {
        this.fnUnsetGridRowHighlighted();
      }, 3000);
    }
  }

  fnUnsetGridRowHighlighted() {
    this.gridData = this.gridData.map((item) => {
      item.isRowHighlighted = false;
      return item;
    });

    this.gridComponent.unsetRowHighlighted(this.gridData);
  }

  fnOnGridCheckAll(params) {
    if (params) {
      this.selectedItemsList = this.gridData;
      this.selectedItemsList = this.selectedItemsList.slice();
      this.fnShowBulkEditGradePanel();
    }
    else {
      this.selectedItemsList = [];
      this.onClosePanel();
    }
  }

  fnOnGridCellClick(params) {
    switch (params.column.colId) {
      case 'selected':
        if (params.data.selected) {
          this.selectedItemsList.push(params.data);
        }
        else {
          this.selectedItemsList = this.selectedItemsList.filter(e => e.gradeId != params.data.gradeId);
        }
        if (this.selectedItemsList.length == 1) {
          this.bulkActionDiv = false;
          this.fnShowSaveGradePanel('edit', this.selectedItemsList[0]);
        }
        else if (this.selectedItemsList.length > 1) {
          this.fnShowBulkEditGradePanel();
        }
        else {
          this.onClosePanel();
        }
        break;
      case 'log':
        this.fnShowConfigureshowLoggingAlertPanel(params.data.gradeId.toString());
        break;
      case 'assignedEmployeeCount':
        this.lstClaimants = [];
        var selectedItem = this.gradeList.filter(d => d.gradeId == params.data.gradeId);
        this.showClaimantPanel = true;
        this.lstClaimants = selectedItem;
        this.panelHeader = this.translate.instant('list_of_claimants_assigned_to').replace('{0}', params.data.gradeName + ': ' + params.data.assignedEmployeeCount);
        break;
      case 'userActionField':
        switch (params.data.userAction) {
          case 1:
            if (!this.selectedItemsList.find(e => e.gradeId != params.data.gradeId)) {
              this.selectedItemsList = [params.data];
              this.gridComponent.checkItems([params.data.gradeId]);
              this.fnShowSaveGradePanel('edit', params.data);
            }
            break;
          case 2:
            this.fnShowSaveGradePanel('copy', params.data);
            break;
        }
        break;
    }
    this.selectedItemsList = this.selectedItemsList.slice();
  }

  fnShowConfigureshowLoggingAlertPanel(FilterID: string = "0") {
    const model = new LoggingPanelModel(
      this.claims.OrgId.toString(),
      LogObjectActionTemplateEnum.Grade.toString(),
      FilterID
    );
    this.loggingPanelService.onShowLogPanel(model);
  }

  getGradeListForAssignEmployee() {

    let gradeRequest = new ApiRequest<IRequestGradeListForAssignEmployee>(
      "SoloGetGradeListForAssignEmployee",
      1.0,
      "111"
    );
    let gradeRequestInfo = new RequestGradeListForAssignEmployee(
      this.claims.OrgId,
      this.statusValue
    );

    gradeRequest.requestInfo = gradeRequestInfo;

    this.gradeService
      .GetGradeListForAssignEmployee(gradeRequest)
      .pipe(first())
      .subscribe(
        (response: any) => {
          if (response.responseInfo != null) {
            this.lstClaimants = [];
            this.gradeList = response.responseInfo.lstEmployee;
          }
        }
      );
  }

  fnPanelReceiver() {
    this.showClaimantPanel = false;
  }

  fnShowSaveGradePanel(action, rowData) {

    this.actionPanelConfig = null;
    let panelKey = '';
    let headerTitle = '';

    let actionButtonConfig = [
      {
        buttonClass: 'btn eod-btn-primary mr-2',
        buttonTooltip: 'label_save',
        key: 'save',

        disableWhenNotDirty: true

      }
    ];

    switch (action) {
      case 'add':
        panelKey = "AddGradePanel";
        headerTitle = "grade_new";
        this.actionPanelModel = {};
        break;
      case 'edit':
        panelKey = "EditGradePanel";
        headerTitle = "grade_edit";
        actionButtonConfig.splice(0, 0, {
          buttonClass: 'btn eod-btn-outline-warning mr-2',
          buttonTooltip: 'label_log',
          key: 'log',
          disableWhenNotDirty: false
        });
        this.actionPanelModel = {
          gradeName: rowData.gradeName,
          gradeDescription: rowData.gradeDescription,
          gradeStatus: rowData.gradeStatus == GradeStatusEnum.Active ? true : false
        };
        break;
      case 'copy':
        panelKey = "CopyGradePanel";
        headerTitle = "grade_copy";
        this.actionPanelModel = {
          gradeName: this.translate.instant("copy_of") + rowData.gradeName,
          gradeDescription: this.translate.instant("copy_of") + rowData.gradeDescription,
          gradeStatus: rowData.gradeStatus == GradeStatusEnum.Active ? true : false
        };
        break;
    }

    this.actionPanelConfig = {
      panelKey: panelKey,
      headerTitle: headerTitle,
      isMultipleSelected: false,
      selectedItemCount: 0,
      formData: this.initializeGradeForm(action),
      buttonConfig: actionButtonConfig,
      disableButtonsOnInvalid: false,
      subtitle: '',
      isOverlay: false
    };
  }

  initializeGradeForm(action) {
    let fields: FormlyFieldConfig[] = [];

    if (action == 'edit') {
      fields.push({
        fieldGroup: [
          {
            key: 'gradeStatus',
            type: 'formly-toggle-input',
            templateOptions: {
              options: [{
                mainClass: "custom-control custom-switch text-left position-relative top--14px margin-left-15 margin-top-10"
              }],
              labelActive: this.translate.instant("label_activate"),
              labelDeactive: this.translate.instant("label_deactivate"),
              change: (field, $event) => {
                this.hasFormChanges = true;
              }
            },
            expressionProperties: {
            }
          }
        ]
      });
    }

    fields.push({
      fieldGroupClassName: 'block row mt-2',
      fieldGroup: [
        {
          key: 'gradeName',
          type: 'text-input',
          className: 'col-xl-6 col-lg-6 col-md-6 col-sm-6 padding-left-0',
          templateOptions: {
            label: this.translate.instant('grade_name'),
            placeholder: '',
            required: true,
            maxLength: 50,
            maxLengthCount: true,
            change: (field, $event) => {
              this.hasFormChanges = true;
            }
          }
        },
        {
          key: 'gradeDescription',
          type: 'text-input',
          className: 'col-xl-6 col-lg-6 col-md-6 col-sm-6 padding-right-0',
          templateOptions: {
            label: this.translate.instant('grade_description'),
            placeholder: '',
            required: true,
            maxLength: 100,
            maxLengthCount: true,
            change: (field, $event) => {
              this.hasFormChanges = true;
            }
          }
        }
      ]
    });

    return fields;
  }

  fnShowBulkEditGradePanel() {
    this.hasFormChanges = false;
    this.actionPanelConfig = null;
    this.actionPanelModel = null;

    this.bulkActionDiv = true;
    this.disableDeactiveButton = false;
  }

  bulkDeactivateGradeConfirm() {
    if (this.gridFilterStatus == GradeStatusEnum.Active) {
      this.fnUnassignEmployees(this.selectedItemsList);
    }
    else {
      this.alertPanelReceiverForBulk(true);
    }
  }

  alertPanelReceiverForBulk(returnValue) {
    if (returnValue) {
      this.bulkDeactiveGrade();
    }
    this.alertPanelModelForBulk = new AlertPanelModel(false, "", [""], "", "", true, this.translate.instant("please_review_or_confirm"));
    if (this.actionPanel.dynamicForm)
      this.actionPanel.dynamicForm.form.markAsDirty();
  }

  alertPanelReceiverForDeactivatingAllGrades(returnValue) {
    this.alertPanelModelForDeactivatingAllGrades = new AlertPanelModel(false, "", [""], "", "", true, this.translate.instant("please_review_or_confirm"));
    if (this.actionPanel.dynamicForm)
      this.actionPanel.dynamicForm.form.markAsDirty();
  }

  bulkDeactiveGrade() {

    this.disableDeactiveButton = true;

    let gradeBulkDeactiveRequest = new ApiRequest<IRequestGradeBulkDeactivate>(
      "SoloBulkDeactiveGrade",
      1.0,
      "111"
    );

    const gradeIds = this.selectedItemsList.map(i => i.gradeId);
    gradeBulkDeactiveRequest.requestInfo = new RequestGradeBulkDeactivate(
      gradeIds,
      this.claims.UserId,
      this.claims.FinanceManager
    );

    let request: Observable<IApiresponse<any>>;
    if (this.gridFilterStatus == GradeStatusEnum.Active) {
      request = this.gradeService.BulkDeactiveGrade(gradeBulkDeactiveRequest);
      this.gridFilterStatus = GradeStatusEnum.Inactive;
    }
    else {
      request = this.gradeService.BulkReactiveGrade(gradeBulkDeactiveRequest);
      this.gridFilterStatus = GradeStatusEnum.Active;
    }

    localStorage.setItem("gradeUpdatedDateTime" + this.claims.OrgId, JSON.stringify(new Date().toUTCString()));

    request.subscribe((response: IApiresponse<any>) => {
      if (response.statusCode == 200) {
        this.toastr.success(this.translate.instant("success"));
        this.hasFormChanges = false;
        this.onClosePanel();
        this.getAllGradeForOrg();
        this.getGradeListForAssignEmployee();
      }
      this.disableDeactiveButton = false;
    });
  }

  onActionPanelSubmit(result: ActionPanelOutput) {
    switch (result.buttonKey) {
      case 'close':
        this.onClosePanel();
        break;
      case 'log':
        const gradeId = this.selectedItemsList[0].gradeId;
        this.fnShowConfigureshowLoggingAlertPanel(gradeId.toString());
        break;
      case 'save':
        this.fnSaveGrade(result, this.selectedItemsList);
    }
  }

  fnUnassignEmployees(selectedItemsList: any) {
    var isEmpAssigned = false;
    if (selectedItemsList.length > 0) {
      for (let i = 0; i < selectedItemsList.length; i++) {
        if (selectedItemsList[i].isAnyEmployeeAssigned == true) {
          isEmpAssigned = true;
        }
      }
    }

    if (selectedItemsList.length > 1) {
      var isDeactivatingAllGrades = this.isDeactivatingAllGrades(selectedItemsList);
      if (isDeactivatingAllGrades) {
        this.showCannotDeactivateAllGradesAlert();
        return true;
      }
    }

    this.alertPanelModelForBulk = new AlertPanelModel(
      true,
      this.translate.instant("label_alert"),
      [isEmpAssigned
        ? this.translate.instant("grade_deactivate_confirm_msg3")
        : this.translate.instant("grade_deactivate_confirm_msg2")],
      this.translate.instant("cancel"),
      this.translate.instant("label_confirm"),
      true,
      this.translate.instant("please_review_or_confirm")
    );

    //return isEmpAssigned ? true : false;
    return true;
  }

  fnSaveGrade(result: ActionPanelOutput, selectedItemList: any) {
    var selectedGrade = this.selectedItemsList.length > 0 ? this.selectedItemsList[0] : null;
    let isValid = this.validateGrade(result.formModel.gradeName, selectedGrade ? selectedGrade.gradeId : 0);
    var isDeactivatingAllGrades = false;
    if (result.panelKey === "EditGradePanel" && result.formModel.gradeStatus == false) {
      isDeactivatingAllGrades = this.isDeactivatingAllGrades(selectedItemList);
    }

    if (!isValid) {
      return;
    }
    else if (isDeactivatingAllGrades) {
      this.showCannotDeactivateAllGradesAlert();
      this.actionPanel.disableButtonsOnInvalid = false;
    }
    else if ((result.formModel.gradeStatus == false && !this.fnUnassignEmployees(selectedItemList))
      || result.formModel.gradeStatus == true
      || typeof (result.formModel.gradeStatus) == 'undefined') {
      let gradeRequest = new ApiRequest<IRequestGrade>(
        "SoloCreateGrade",
        1.0,
        "111"
      );
      gradeRequest.requestInfo = new RequestGrade(
        this.claims.OrgId,
        result.formModel.gradeName,
        result.formModel.gradeDescription,
        GradeStatusEnum.Active,
        false,
        this.claims.UserId,
        this.claims.FinanceManager
      );

      let request: Observable<IApiresponse<any>>;
      if (selectedGrade) {
        gradeRequest.requestInfo.gradeId = selectedGrade.gradeId;
        gradeRequest.requestInfo.createdDate = selectedGrade.createdDate;
        gradeRequest.requestInfo.createdBy = selectedGrade.createdBy;
        gradeRequest.requestInfo.isDefault = selectedGrade.isDefault;
        gradeRequest.requestInfo.modifiedBy = this.claims.UserId;
        gradeRequest.requestInfo.modifiedDate = new Date();
        if (result.formModel.gradeStatus) {
          gradeRequest.requestInfo.gradeStatus = GradeStatusEnum.Active;
        }
        else {
          gradeRequest.requestInfo.gradeStatus = GradeStatusEnum.Inactive;
        }

        request = this.gradeService.UpdateGrade(gradeRequest);
      }
      else {
        request = this.gradeService.CreateGrade(gradeRequest);
      }

      localStorage.setItem("gradeUpdatedDateTime" + this.claims.OrgId, JSON.stringify(new Date().toUTCString()));

      request.subscribe((response: IApiresponse<any>) => {
        if (response.statusCode == 200) {
          this.toastr.success(this.translate.instant("success"));
          this.hasFormChanges = false;
          this.onClosePanel();
          this.getAllGradeForOrg();
        } else {
          this.toastr.error(response.message);
        }
      });
    }
    else {
      this.actionPanel.disableButtonsOnInvalid = false;
      return;
    }
  }

  validateGrade(gradeName, gradeId) {
    let isValid: boolean = true;
    let gradeErrors = [];
    var existingGrade = this.gradeAllList.find((it) => it.gradeName.trim().toLowerCase() == gradeName.trim().toLowerCase()
      && it.gradeId != gradeId);
    if (existingGrade) {
      isValid = false;
      gradeErrors.push(this.translate.instant('name_exist'));
    }

    let employeeEmailField = GetField('gradeName', this.actionPanelConfig.formData);
    if (employeeEmailField) {
      employeeEmailField.templateOptions.customErrors = gradeErrors;
    }

    return isValid;
  }

  isDeactivatingAllGrades(selectedItemsList: any) {
    let activeGradesCount = this.gradeAllList.filter(g => g.gradeStatus == GradeStatusEnum.Active).length;
    return selectedItemsList.length == activeGradesCount;
  }

  showCannotDeactivateAllGradesAlert() {
    this.alertPanelModelForDeactivatingAllGrades = new AlertPanelModel(
      true,
      this.translate.instant("label_alert"),
      [this.translate.instant("cannot_deactivate_all_grades_info")],
      "",
      this.translate.instant("label_ok"),
      true,
      this.translate.instant("please_review_or_confirm")
    );
  }

  onClosePanel() {
    if (this.canDeactivate()) {
      this.hasFormChanges = false;
      this.actionPanelConfig = null;
      this.actionPanelModel = null;
      this.bulkActionDiv = false;
      this.disableDeactiveButton = false;
      this.selectedItemsList = [];
      this.gridComponent.uncheckAll();
    } else {
      this.alertService.onFormClosed();
    }
  }

  checkAssigncategoriestogradeSubscribed() {
    this.organisationSettingService
      .getSubscribedFunctionsForOrganisation(this.claims.OrgId)
      .subscribe((subsData) => {
        var assigncategoriestograde = subsData.responseInfo.find(
          (x) => x.functionID == FunctionPackageEnum.assigncategoriestograde
        );
        if (assigncategoriestograde) {
          this.isAssigncategoriestogradeSubscribed = true;
        } else {
          this.isAssigncategoriestogradeSubscribed = false;
        }
      });
  }

  gotoAssigncategoriestograde() {
    if (this.isAssigncategoriestogradeSubscribed) {
      this.fnShowAssignCategoriesToGradeListPanel();
    } else {
      this.showAssignCategorieToGradePopup = true;
    }
  }

  closeAssigncategoriestogradePopup() {
    this.showAssignCategorieToGradePopup = false;
  }

  goToImportGrade() {
    this.router.navigate(["orgsetting/gradeimport"]);
  }

  goToSetting() {
    if (
      localStorage.getItem("isRedirectFromMySubscriptionSettingPage") == "1"
    ) {
      this.router.navigate(["mysubscription"]);
    } else {
      this.router.navigate(["settings"]);
    }
  }

  fnShowAssignCategoriesToGradeListPanel() {
    this.assignCategoriesToGradeListPanelInputModel = new AssignCategoriesToGradeListPanelInputModel(
      this.translate.instant("assign_categories_to_grade")
    );
    this.showAssignCategoriesToGradeListPanel = true;
  }

  fnCloseAssignCategoriesToGradeListPanel() {
    this.showAssignCategoriesToGradeListPanel = false;
    this.assignCategoriesToGradeListPanelInputModel = null;
  }
  @Output() closePanelEvent = new EventEmitter<boolean>();
  closePanel() {
    this.isGradePanelOpen = false;
    this.closePanelEvent.emit(true);

  }

}
